import useFeatureToggles from './useFeatureToggles';

export const useIsRjCommunicationBulkEnabled = (): boolean => {
  const { isFeatureToggleEnabled } = useFeatureToggles();
  const isHubEnabled = isFeatureToggleEnabled((ft) => ft.RJ_COMMUNICATION_HUB);
  const isBulkEnabled = isFeatureToggleEnabled((ft) => ft.RJ_COMMUNICATION_BULK);
  return isHubEnabled && isBulkEnabled;
};
